import React from 'react';
import {TeamImage, Stat, Team, Content, Container, RankStat} from 'app/components/standings/StandingsStyles';
import {LinkOnComponent} from 'app/components/links/link';
import {Image, Line, Typography} from '@fupa/fupa-uikit';
import {parseNumber, round} from 'app/helpers/helpers';
import {convertToRoman} from 'app/helpers/convertToRoman';
import styled from 'styled-components';

const SpectatorsContainer = styled(Container)`
  &&& {
    background-color: transparent;
  }
`;

const LeagueTableRow = ({team, index}) => {
  const name =
    team.team.level > 1 ? `${team.team.name.middle} ${convertToRoman(team.team.level)}` : team.team.name.middle;
  const totalSpectators = parseNumber(team.total);
  const avgSpectators = parseNumber(team.avg);

  return (
    <Content>
      <LinkOnComponent enablehover={true.toString()} to={`/team/${team.team.slug}`}>
        <SpectatorsContainer height={42}>
          <RankStat align='left' minWidth={24} setMaxWidth={true}>
            <Typography variant='body1'>{index + 1}.</Typography>
          </RankStat>
          <TeamImage>
            <Image entity='emblem' src={team.team.image} width={32} height={32} fit={true} />
          </TeamImage>
          <Team>
            <Typography variant='body1'>{name}</Typography>
          </Team>
          <Stat align='center' minWidth={32}>
            <Typography variant='body1'>{team.matches}</Typography>
          </Stat>
          <Stat align='center' minWidth={48}>
            <Typography variant='body1'>{totalSpectators}</Typography>
          </Stat>
          <Stat align='center' minWidth={36}>
            <Typography variant='body1'>{avgSpectators}</Typography>
          </Stat>
        </SpectatorsContainer>
      </LinkOnComponent>
      <Line />
    </Content>
  );
};

export default LeagueTableRow;
